import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBlackFridayBanner } from './NewbuildingBlackFridayBanner';
import {
  selectNewbuildingBlackFridayListingBannerImage,
  selectNewbuildingBlackFridayUrl,
} from '../../../selectors/newbuildingBlackFriday';

export function NewbuildingBlackFridayBannerContainer() {
  const url = useSelector(selectNewbuildingBlackFridayUrl);
  const image = useSelector(selectNewbuildingBlackFridayListingBannerImage);

  return <NewbuildingBlackFridayBanner url={url} image={image} />;
}
